import { StylesParser } from '../StylesParser'
import { RowBuilder } from './RowBuilder'
import { ClassesBuilder } from "./ClassesBuilder";

export class SectionBuilder {
  constructor(section) {
    this.section = section
  }

  build() {
    this.sectionClasses = this.getSectionClasses()
    window.StylesBuilder.add(this.getSectionStyles())
    this.id = this.section.id
    this.rows = this.section.rows.map(row => new RowBuilder(row).build()).join('')
    return this.buildHtml()
  }

  getSectionClasses() {
    return new Object({
      classes: (new ClassesBuilder(this.section.classes)).parseClasses().join(' '),
    })
  }

  getSectionStyles() {
    return {
      id: `#${this.section.id}`,
      styles: {
        desktop: (new StylesParser(this.section.styles, 'desktop')).parse(),
        tablet: (new StylesParser(this.section.styles, 'tablet')).parse(),
        phone: (new StylesParser(this.section.styles, 'phone')).parse()
      }
    }
  }

  buildHtml() {
    return `<div id="${this.id}" class="${this.sectionClasses.classes}">
      ${this.rows}
    </div>`
  }
}
